import { useEffect, useRef, useState, type FormEvent } from 'react';
import { api } from '../api';
import { useTitle } from '../shortcuts';

/** Shown in server mode until you sign in. One user, one password. */
export function LoginPage({ onSignedIn }: { onSignedIn: () => void }) {
  useTitle('Sign in');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const input = useRef<HTMLInputElement>(null);
  useEffect(() => input.current?.focus(), []);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (!password) {
      setError('Enter your password.');
      input.current?.focus();
      return;
    }
    setBusy(true);
    setError('');
    try {
      await api.login(password);
      setPassword('');
      onSignedIn();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not sign in. Try again.');
      input.current?.focus();
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="mu-login">
      <div className="mu-login-brand">
        <img src="/logo.svg" alt="" width={48} height={48} />
        <h1>Muddle</h1>
      </div>
      <form className="card" onSubmit={(e) => void submit(e)} noValidate>
        <h2 className="card-title">Sign in</h2>
        <div className="field">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            ref={input}
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            aria-invalid={!!error}
            aria-describedby={error ? 'login-err' : undefined}
          />
          {error && (
            <div className="field-error" id="login-err" role="alert">
              {error}
            </div>
          )}
        </div>
        <button
          className="btn btn-primary btn-block"
          type="submit"
          disabled={busy}
          aria-busy={busy}
        >
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </main>
  );
}
